import { HttpErrorResponse } from "@angular/common/http";

export class StarResponse{

    stars:                              Star[] = [new Star()];
    error:                              HttpErrorResponse | null = null;
}

export class Star{
    name                                = '';
    type                                = '';
}